// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"1b35558f","127":"4bf63199","252":"ecc33e3d","327":"d2aff142","337":"61abf38d","381":"b1275847","762":"56fae100","799":"5d9c36e3","820":"4f481a6b","853":"18d85432","993":"56d57160","998":"a95d007a"}[chunkId] + ".chunk.js";
};